// extracted by mini-css-extract-plugin
module.exports = {"className":"textBodyLinkM_className__QAb_D"};